import React from 'react';
import styles from './common_carousel.module.scss';

export const Chips = (props: React.HTMLProps<HTMLDivElement>) => (
  <div className={styles.chips} {...props} />
);

export const ChipsWrapper = React.forwardRef(
  (props: React.HTMLProps<HTMLDivElement>, ref?: React.Ref<HTMLDivElement>) => (
    <div {...props} ref={ref} className={styles.wrapper} />
  ),
);

export const ChipsInnerWrapper = (props: React.HTMLProps<HTMLDivElement>) => (
  <div className={styles.inner} {...props} />
);
